import { useLocation, useNavigate } from 'react-router-dom';
import {BiListUl, BiNetworkChart} from "react-icons/bi";
import React, { useEffect, useState } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import {BsLayersHalf} from "react-icons/bs";
import {FiGlobe} from "react-icons/fi";

import HelpGlobalNetwork from "../components/help/HelpGlobalNetwork";
import HelpSubnetwork from "../components/help/HelpSubnetwork";
import HelpList from "../components/help/HelpList";
import HelpOverlay from "../components/help/HelpOverlay";
import PageFooter from "../components/PageFooter";
import "../css/help.css";

const Help: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeKey, setActiveKey] = useState('network');
  const [isReady, setIsReady] = useState(false);

  // Set active tab based on hash in URL
  useEffect(() => {
    const hash = location.hash.replace('#', '');
    if (hash && ['network', 'subnetwork', 'list', 'overlay'].includes(hash)) {
      setActiveKey(hash);
    }
    setIsReady(true);
  }, [location.hash]);

  // Update URL when tab changes
  const handleSelect = (key: string | null) => {
    if (key) {
      setActiveKey(key);
      navigate(`#${key}`, {replace: true});
    }
  };

  return (
    <div id="help-page" className="bg-white overflow-auto h-100">
      {isReady && (
        <div className="container py-4">
          <h1 className="mb-4">Documentation</h1>
          <Tabs activeKey={activeKey} onSelect={handleSelect} className="mb-3">
            <Tab eventKey="network" title={<span className="d-flex align-items-center gap-1"><FiGlobe/>Global Network</span>}>
              <HelpGlobalNetwork/>
            </Tab>
            <Tab eventKey="subnetwork" title={<span className="d-flex align-items-center gap-1"><BiNetworkChart/>Subnetwork</span>}>
              <HelpSubnetwork/>
            </Tab>
            <Tab eventKey="list" title={<span className="d-flex align-items-center gap-1"><BiListUl/>List</span>}>
              <HelpList/>
            </Tab>
            <Tab eventKey="overlay" title={<span className="d-flex align-items-center gap-1"><BsLayersHalf/>Overlay Data</span>}>
              <HelpOverlay/>
            </Tab>
          </Tabs>
        </div>
      )}
      <PageFooter/>
    </div>
  );
};

export default Help;